import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Card, ListGroup } from "react-bootstrap";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import jury from "../../../../../../assets/images/pendingIcons/jury.png";
import star from "../../../../../../assets/images/pendingIcons/star.png";
import noImage from "../../../../../../assets/images/settings/no-image.png";
import "./AdminRequestForApproval.css";
import AssignedGroupJuries from "./AssignedGroupJuries";

const AdminRequestForApproval = () => {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const audio = true;
  const video = true;
  let { slug } = useParams();

  const [event, setEvent] = useState([]);
  const [judge, setJudge] = useState([]);
  const [juryGroups, setJuryGroups] = useState([]);


  useEffect(() => {
    axios.get(`/api/audition-admin/audition-event/for-approval/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setJudge(res.data.event.assigned_judges);
        setJuryGroups(res.data.juryGroups);
      }
    });
  }, [slug]);
  return (
    <>
      {audio && video ? (
        <>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 mb-3">
              <div className="card card-bg p-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid"
                  style={{ height: "330px" }}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 mb-3">
              <div className="card card-bg p-2">
                <ReactPlayer
                  url={videoCdnUrl + event.video}
                  controls
                  playing={false}
                  volume={1}
                  height="330px"
                  width="100%" // height="200px" // style={{ margin: "0 auto" }}
                />
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">{event.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="row px-3 pt-0">
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="card card card-bg-event head-line px-3 mt-3">
                      <h5 className="text-warning pt-2 ">
                        User Registration Start
                      </h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(event.user_reg_start_date).format("LL")}
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="card card card-bg-event head-line px-3 mt-3">
                      <h5 className="text-warning pt-2 ">
                        User Registration End
                      </h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(event.user_reg_end_date).format("LL")}
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="card card card-bg-event head-line px-3 mt-3">
                      <h5 className="text-warning pt-2 ">Event Start Date</h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(event.start_date).format("LL")}
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="card card card-bg-event head-line px-3 mt-3">
                      <h5 className="text-warning pt-2 ">Event End Date</h5>
                      <p className="text-light fw-bold pt-2">
                        {moment(event.end_date).format("LL")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="requestApprovalBottomLine mb-4"></div>

          <div className="mainBorderPending">
            <div className="p-3">
              <div className="row justify-content-center">
                <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
                  <div className="card card-bg pb-3">
                    <div className="d-flex bg-black text-center text-light fw-bold align-items-center justify-content-center p-2">
                      <img src={star} width="30px" alt="" />
                      &nbsp;&nbsp;<h5>Star panel</h5>
                    </div>

                    {judge.map((judge) => (
                      <div className="d-flex star-panel ps-3 pe-1 pt-3 align-items-center">
                        <img
                          className="demoStar auditionAvatar"
                          src={
                            judge.user?.image
                              ? imageCdnUrl + judge.user?.image
                              : noImage
                          }
                          alt=""
                        />
                        <div className="star-name px-3">
                          <h6>
                            {judge.user?.first_name +
                              " " +
                              judge.user?.last_name}
                          </h6>
                          <small>
                            {judge.approved_by_judge === 1 ? (
                              <span className="text-success">Approved</span>
                            ) : judge.approved_by_judge === 0 ? (
                              <span className="text-warning">pending</span>
                            ) : (
                              <span className="text-danger">Rejected</span>
                            )}
                          </small>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
                  <div className="card card-bg pb-3">
                    <div className="d-flex bg-black text-center text-light fw-bold align-items-center justify-content-center p-2">
                      <img src={star} width="30px" alt="" />
                      &nbsp;&nbsp;<h5>Admin panel</h5>
                    </div>
                    {judge.map((judge) => (
                      <div className="d-flex star-panel px-3 pt-3 align-items-center">
                        <img
                          className="demoStar auditionAvatar"
                          src={
                            judge.user?.admin?.image
                              ? imageCdnUrl + judge.admin?.image
                              : noImage
                          }
                          alt=""
                        />
                        <div className="star-name px-3">
                          <h6>
                            {judge.admin?.first_name} {judge.admin?.last_name}
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row my-4 justify-content-lg-center">
                <h3 className="judge-panel-x text-center p-2 text-light mb-3">
                  &nbsp; Jury Boards
                </h3>

                {juryGroups.map((group) => (
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3 ">
                    <div className="card card-bg">
                      <div className="d-flex bg-black text-center text-light fw-bold align-items-center justify-content-center p-2">
                        <img src={jury} width="30px" alt="" />
                        &nbsp;&nbsp;
                        <h4>{group.name}</h4>
                      </div>

                      <AssignedGroupJuries
                        audition_id={event.id}
                        group={group.id}
                      />
                    </div>
                  </div>
                ))}
              </div>

              {Number(event.status) <= 2 ? (
                <div className="col-md-3 mx-auto">
                  <h3 className="btn btnCreate fw-bold w-100">
                    Pending For Manager Approval
                  </h3>
                </div>
              ) : (
                <div className="col-md-3 mx-auto">
                  <button className="btn border-success  w-100">
                    <h6 className="text-success fw-bold">
                      Manager Admin Post Done
                    </h6>
                  </button>
                </div>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default AdminRequestForApproval;
